import React from 'react';

const Colorado = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Colorado Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Must disclose special taxing districts, common interest communities,
          and meth lab usage.
        </li>
        <li>Seller’s Property Disclosure: Required for residential sales.</li>
        <li>
          A buyer of residential real property has the right to test the
          property for the purpose of determining whether the property has ever
          been used as a methamphetamine laboratory.
        </li>
        <li>
          Inspection Objection: Buyers must submit objections within a specified
          timeframe.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Colorado-Residential-Property-Green-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Green Disclosure{' '}
          </span>{' '}
          – For properties that contain or are equipped with energy-related
          features and technologies.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/10/Colorado-Sellers-Residential-Property-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – In accordance with the U.S. Consumer Product Safety Commission, the
          seller must provide this form to a potential buyer for properties
          built before 1978.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Colorado-Radon-Disclosure-Sales.pdf',
                '_blank'
              );
            }}
          >
            Radon Disclosure{' '}
          </span>{' '}
          – Sellers must disclose any knowledge of radon concentrations and
          provide a warning on the dangers of radon to prospective buyers.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/10/Colorado-Sellers-Residential-Property-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure{' '}
          </span>{' '}
          – A comprehensive disclosure form covering state-mandated
          requirements, including taxing districts, common interest community,
          meth lab, potable water, transportation projects, and oil and gas
          activity.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/10/Colorado-Sellers-Residential-Property-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Transportation Projects Disclosure{' '}
          </span>{' '}
          – Sellers must disclose any nearby transportation projects in the
          property disclosure.
        </li>
      </ol>
    </div>
  );
};

export default Colorado;
